module.exports = __webpack_public_path__ + "static/slider-3-bd1a00a1250e9bdca903cd55cc215a25.png";